import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@components/structure/Header/Header";
import Footer from "@components/structure/Footer/Footer";
import useProcessCoupon from "@hooks/process-coupon";
import { Helmet } from "react-helmet";
import { getRegion } from "@util/domain";
import styles from "./AppLayout.module.css";

const AppLayout: React.FC = () => {
    useProcessCoupon();
    return (
        <div className={styles.appContainer}>
            <Helmet>
                <title>Memorial Hub | Forever In Our Hearts</title>
                <meta
                    name="description"
                    content={`Manage your online memorials and tributes. Easily update, ${getRegion() === "global" ? "personalize" : "personalise"}, and share your loved one’s legacy pages with family and friends.`}
                />
            </Helmet>
            <Header variant="private" />
            <main className={styles.main}>
                <Outlet />
            </main>
            <Footer isLoggedIn />
        </div>
    );
};

export default AppLayout;
